<template>
    <div
        class="relative h-full"
    >
        <page-header
            :show-submit-button="false"

            :can-delete="!data.usage.length"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="false"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <rocket-link
            :language="data.language"
            :disabled="true"
            :value="data"
        />

        <div
            v-if="data.usage.length"
            class="border bg-white rounded-lg shadow p-4"
        >
            <h3 class="mb-3">Usages</h3>
            <ul>
                <li v-for="document in data.usage">
                    <a :href="document.edit_route">{{ document.edit_route }} => ( {{ document.path.join(', ') }} )</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import crudForm from "../mixins/crudForm";
import Reference from "./reference";
import InputCheckbox from "./form/InputCheckbox";
import RocketLink from "./Link/RocketLink.vue";
export default {
    name: "LinkForm",
    components: {RocketLink, InputCheckbox, Reference },
    mixins: [crudForm],
    props: {
        linkableTypes: {
            type: Array,
            default: () => [
                "Casino Review",
                "Slot Review",
                "Game Review",
                "Author",
                "Category",
            ],
        },
    },
    data() {
        return {

        };
    },
    watch: {
    },
};
</script>
